import * as React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { withCookies } from 'react-cookie';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import TrackME from '../modules/trackMe';
import Identity from '../modules/identity';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import LoginCookie from '../loginCookie/LoginCookie';
import './SearchPNRFormContainer.css';
import ModalLoad from '../../components/modalLoad/ModalLoad';
import ForgotPasswordModal from '../login/components/ForgotPasswordModal';

const POST_LOGIN_V1 = '/platform-session/api/v1/login/';
const POST_CUSTOMER_V1 = '/platform-session/api/v1/customer';

const I18n = require('i18n-react').default;

const propTypes = {
  id: PropTypes.string,
  setCheckboxBorderNameCallback: PropTypes.func,
  flightsFilter: PropTypes.object,
  analyticsDataSelect: PropTypes.object,
  callbackAlterSearch: PropTypes.func,
  isCallcenterEnabled: PropTypes.bool
};

const defaultProps = {
  showLoginLoading: false
};

class SearchPNRFormContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isRedirect: false,
      pathname: '',
      isLoginFilled: true,
      isPasswordFilled: true,
      isButtonDisabled: true,
      login: '',
      password: '',
      isLoginInCookie: false,
      showLoginLoading: false,
      pointsBalance: {
        display: false,
        name: '',
        totalPoints: 0,
        differenceTotalPoints: 0,
        callbackAlterSearch: this.props.callbackAlterSearch
      },
      openModal: false,
      messageInfo: null,
      isLoginInCookie: false,
      isModalVisibility: false
    };

    this.changeModalState = this.changeModalState.bind(this);
  }

  validate = event => {
    event.preventDefault();
    let isLoginValid = this.validateLogin();
    let isPasswordValid = this.validatePassword();
    let isValid = isLoginValid && isPasswordValid;
    if (isValid) {
      // this.redirect();
      this.login(this.state.login, this.state.password);
    } else {
      this.props.setCheckboxBorderNameCallback('invalidField');
    }
    return isValid;
  };


  changeModalState = () => {   
      this.setState({
        isModalVisibility: true
      });    
  };

  redirect = () => {
    this.setState({
      isRedirect: true,
      pathname: '/searchResult'
    });
  };

  handleLoginChange = event => {
    let isButtonDisabled = true;
    if (event.target.value && this.state.password) {
      isButtonDisabled = false;
    }
    this.setState({
      login: event.target.value,
      isButtonDisabled: isButtonDisabled
    });
  };

  handlePasswordChange = event => {
    let isButtonDisabled = true;
    if (this.state.login && event.target.value) {
      isButtonDisabled = false;
    }
    this.setState({
      password: event.target.value,
      isButtonDisabled: isButtonDisabled
    });
  };

  validateLogin = () => {
    let isValidState = this.state.login.length > 9;

    this.setState({
      isLoginFilled: isValidState
    });

    return isValidState;
  };

  validatePassword = () => {
    let isValidState = this.state.password.length > 0;

    this.setState({
      isPasswordFilled: isValidState
    });

    return isValidState;
  };

  renderValidationMessage(isFieldFilled, message) {
    let footer = <Row id={`${this.props.id}__errorMessageFooter`} className="Field__message" />;

    if (!isFieldFilled) {
      footer = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}__errorMessageFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(message)}</span>
          </Col>
        </Row>
      );
    }

    return footer;
  }

  featureIdentity(sessionId, domain) {
    Identity.capturar(sessionId, domain);
  }

  getInvalidLoginMessage() {
    let telLabel = I18n.translate('components.login.tudoAzulTel');
    let emailLabel = I18n.translate('components.login.tudoAzulEmail');
    let tel = <a href={`tel:${telLabel}`}> {telLabel} </a>;
    let email = <a href={`mailto:${emailLabel}`}> {emailLabel} </a>;

    return I18n.translate('components.login.invalidLoginErrorMessage', { tel: tel, email: email });
  }

  getInvalidLogin_401_Message() {
    return I18n.translate('components.login.invalidLoginError401Message');
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      messageInfo: null
    });
  }

  login(loginValue, password) {
    let body = {
      customerLogin: {
        login: loginValue,
        password: password
      }
    };

    let data, message, statuscode;
    this.setState({
      showLoginLoading: true
    });
    return fetch(POST_LOGIN_V1, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      credentials: 'same-origin'
    })
      .then(res => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 422) {
          message = this.getInvalidLoginMessage();
          throw res.json();
        } else if (res.status === 401) {
          statuscode = 401;
          throw res.json();
        } else {
          throw res.json();
        }
      })
      .then(body => {
        data = body;
        return fetch(POST_CUSTOMER_V1, {
          method: 'GET',
          headers: new Headers({
            'Content-Type': 'application/json',
            username: data.username
          }),
          credentials: 'same-origin'
        });
      })
      .then(res => {
        if (res.ok) {
          return res.json();
        } else {
          throw res.json();
        }
      })
      .then(body => {
        data = { ...data, ...body };
        this.setState({
          data: data,
          isLoginInCookie: true,
          showLoginLoading: false
        });
        TrackME.run(loginValue, 'LOGIN');
        this.featureIdentity(loginValue, 'LOGIN');
        this.redirect();
      })
      .catch(promise => {
        this.setState({
          isLoginInCookie: false,
          showLoginLoading: false
        });
        let description = '';
        let reason = '';
        let telLabel = I18n.translate('components.login.tudoAzulTel');
        let emailLabel = I18n.translate('components.login.tudoAzulEmail');
        let tel = <a href={`tel:${telLabel}`}> {telLabel} </a>;
        let email = <a href={`mailto:${emailLabel}`}> {emailLabel} </a>;
        promise
          .then(value => {
            message = value.message;
            description = value.description;
            reason = value.reason;
            if (statuscode === 401) {
              message = this.getInvalidLogin_401_Message();
              this.showModal(message);
            } else if (message != null && description != null && reason != null) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Mensagem: </p>
                  <p>{I18n.translate(message, { tel: tel, email: email })}</p>
                  <br />
                  <p>Descrição: </p>
                  <p>{description}</p>
                  <br />
                  <p>Razão: </p>
                  <p>{reason}</p>
                </div>
              );
              this.showModal(text);
            } else if (message != null && description != null) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Mensagem:</p>
                  <p>{I18n.translate(message, { tel: tel, email: email })}</p>
                  <br />
                  <p>Descrição: </p>
                  <p>{description}</p>
                </div>
              );
              this.showModal(text);
            } else if (message) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Mensagem: </p>
                  <p>{I18n.translate(message, { tel: tel, email: email })}</p>
                </div>
              );
              this.showModal(text);
            } else if (description) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Descrição: </p>
                  <p>{description}</p>
                </div>
              );
              this.showModal(text);
            } else if (reason) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Razão: </p>
                  <p>{reason}</p>
                </div>
              );
              this.showModal(text);
            } else {
              this.showModal(I18n.translate('home.msg.error'));
            }
          })
          .catch(() => {
            if (message) {
              this.showModal(message);
            } else {
              this.showModal(I18n.translate('home.msg.error'));
            }
          });
      });
  }

  setDisabledButton() {
    if (this.state.isLoginFilled && this.state.isPasswordFilled) {
      return false;
    }
    return true;
  }

  getLoginCookie = user => {
    if (user) {
      this.setState({
        isLoginInCookie: true
      });
    }
  };

  renderModalLoading() {
    return (
      <ModalLoad
        id="modalLoad"
        showModal={this.state.showLoginLoading}
        ref={c => {
          this.modalLoad = c;
        }}
      />
    );
  }


  renderForm() {
    return (
      <form onSubmit={this.validate}>
        <Row className="d-flex flex-row">
          <Col xs={12} md={6} className="padding-eight-32">
            <Row className="Field__label">
              <Col id={`${this.props.id}_loginLabel`}>
                <span
                  className={
                    this.state.isLoginFilled ? 'Field__validField' : 'Field__invalidField'
                  }>
                  {I18n.translate('label.cpfOrAzulFidelidade').toString()}
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <input
                  type="text"
                  id={`${this.props.id}_loginField`}
                  onChange={this.handleLoginChange}
                  onBlur={this.validateLogin}
                  placeholder={I18n.translate('placeholder.cpfOrAzulFidelidade').toString()}
                  className={`Field__input ${this.state.isLoginFilled ? 'Field__validInput' : 'Field__invalidInput'
                    }`}
                  value={this.state.login}
                  maxLength={11}
                />
              </Col>
            </Row>
            {this.renderValidationMessage(
              this.state.isLoginFilled,
              'components.login.cpfErrorMessage'
            )}
          </Col>
          <Col xs={12} md={6} className="padding-eight-32">
            <Row className="Field__label">
              <Col id={`${this.props.id}_passwordLabel`}>
                <span
                  className={
                    this.state.isPasswordFilled ? 'Field__validField' : 'Field__invalidField'
                  }>
                  {I18n.translate('label.password').toString()}
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <input
                  type="password"
                  id={`${this.props.id}_passwordField`}
                  onChange={this.handlePasswordChange}
                  onBlur={this.validatePassword}
                  placeholder={I18n.translate('placeholder.password').toString()}
                  className={`Field__input ${this.state.isPasswordFilled ? 'Field__validInput' : 'Field__invalidInput'
                    }`}
                  value={this.state.password}
                  maxLength={18}
                />
              </Col>
            </Row>
            {this.renderValidationMessage(
              this.state.isPasswordFilled,
              'components.login.passwordErrorMessage'
            )}
            <Row>
              <Col xsHidden mdOffset={7} md={4} className="text-right Login__forgotPasswordSearch">
                <a
                 onClick={() => {
                  this.changeModalState()
                 }}                  
                  className="Login__forgotPasswordLabelSearch"                 
                  rel="noopener noreferrer">
                  {I18n.translate('components.login.forgotPassword')}
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="padding-eight-horizontal-40 padding-eight-vertical-32 SearchPNRFormContainer__buttonContainer">
          <Col span={18} />
          <Col span={6} className="text-right">
            <Button
              id="btnLogin"
              type="submit"
              className="btnOkLoginPNR"
              disabled={this.setDisabledButton()}>
              {I18n.translate('label.login')}
            </Button>
          </Col>
        </Row>
      </form>
    );
  }

  render() {
    return (
      <div>
        {this.renderForm()}
        <InfoModal
          id="modalLoginInfo"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={() => this.closeModal()}
          ref={c => {
            this.modalLoginInfo = c;
          }}
        />
        <ForgotPasswordModal
          close={() => {
            this.setState({
              isModalVisibility: false
            })
          }}
          showModal={this.state.isModalVisibility}
        />
        {this.state.showLoginLoading ? this.renderModalLoading() :
          this.state.isRedirect ? (
            <Redirect
              push
              to={{
                pathname: this.state.pathname,
                state: {
                  customer: this.state.data
                }
              }}
            />
          ) : (
            <LoginCookie
              callbackCookie={this.getLoginCookie}
              data={this.state.data}
              callcenterMode={false}
            />
          )}
      </div>
    );
  }
}

SearchPNRFormContainer.propTypes = propTypes;
SearchPNRFormContainer.defaultProps = defaultProps;

export default withCookies(SearchPNRFormContainer);



// WEBPACK FOOTER //
// ./src/components/searchPNRFormContainer/SearchPNRFormContainer.jsx